import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Analytics Graph Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M.75.75v22.5h22.5M15.937 8.578l4.493-5.616M9.621 7.359l4.008 1.781M.75 11.25l6.214-3.728M15.561 16.521l4.74-2.633M8.25 17.25h4.5M.75 20.25l4.658-2.329"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M6.75 6.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M13.5 9.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M20.25 2.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M20.25 13.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M12.75 17.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M5.25 17.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"
    }, null, -1)
  ]))]))
}
export default { render: render }